<template>
    <b-modal
        centered
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        v-model="form.show"
    >
        <template #modal-header="{}">
            <div class="header flex-grow-1 text-center">
                <h2 class="font-weight-bold">เพิ่มรถ</h2>
            </div>
            <span class="close cursor-pointer" @click="closeModalConfirm()">&times;</span>
        </template>
        <ValidationObserver ref="observer">
            <b-form @submit="onSubmit">
                <card shadow type="secondary" class="m--4">
                    <b-row>
                        <b-col cols="6">
                            <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                                <b-form-group label="ประเภทรถ">
                                    <multiselect
                                        v-model="form.car.vehicleType"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label="name"
                                        placeholder="ค้นหาประเภทรถ"
                                        :options="LIST_TYPE_CAR"
                                        :allow-empty="false"
                                        :class="{
                                            'custom-select-error': errors[0]
                                        }"
                                    ></multiselect>
                                    <p class="custom-meassage-error" v-if="errors[0]">
                                        {{ errors[0] }}
                                    </p>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="ทะเบียนรถ">
                                    <b-form-input
                                        placeholder="ระบุทะเบียนรถ"
                                        v-model="form.car.vehiclePlate"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="จังหวัด">
                                    <b-form-input
                                        placeholder="ระบุจังหวัด"
                                        v-model="form.car.province"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="ยี่ห้อ">
                                    <b-form-input
                                        placeholder="ระบุยี่ห้อ"
                                        v-model="form.car.brand"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="ปีที่ผลิต">
                                    <b-form-input
                                        placeholder="ระบุปีที่ผลิต"
                                        v-model="form.car.yearCreate"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="ชนิดเครื่องยนตร์">
                                    <b-form-input
                                        placeholder="ระบุชนิดเครื่องยนตร์"
                                        v-model="form.car.engineType"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="ขนาดเครื่องยนตร์">
                                    <b-form-input
                                        placeholder="ระบุขนาดเครื่องยนตร์"
                                        v-model="form.car.engineSize"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="ระบบขับเคลื่อน">
                                    <b-form-input
                                        placeholder="ระบุระบบขับเคลื่อน"
                                        v-model="form.car.driveSystem"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <template slot="footer">
                        <b-row class="justify-content-between">
                            <b-col cols="4">
                                <b-button
                                    block
                                    @click="closeModalConfirm()"
                                >
                                    ยกเลิก
                                </b-button>
                            </b-col>
                            <b-col cols="6">
                                <b-button 
                                    type="submit" 
                                    variant="primary"
                                    block
                                    :disabled="form.isLoad"
                                >
                                    <i class="fas fa-circle-notch fa-spin" v-if="form.isLoad"></i> 
                                    ยืนยัน
                                </b-button>
                            </b-col>
                        </b-row>
                    </template>
                </card>
            </b-form>
        </ValidationObserver>
    </b-modal>
</template>

<script>
import carServices from "@/api/car.service.js";
import vehicleTypeService from "@/api/vehicle-type.service.js"
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { modalSuccess, modalError } from '@/util/alert.js'
import { lab } from "d3";

export default {
    props: {
        form: {
            type: Object
        }
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return { 
            LIST_TYPE_CAR : []
        }
    },
    async mounted(){
        await this.getCategory();
    },
    methods: {
        async getCategory (){
            const { data } = await vehicleTypeService.getVehicleCategory()
            this.LIST_TYPE_CAR = data.data;
        },
        async onSubmit(event) {
            event.preventDefault();
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }
  
            const { 
                vehicleType, 
                vehiclePlate, 
                province, 
                brand, 
                yearCreate, 
                engineType, 
                engineSize,
                driveSystem,
            } = this.form.car

            const payload = {
                vehicle_category_id: vehicleType.id,
                plate: vehiclePlate,
                province,
                brand,
                year_created: yearCreate,
                engine_type: engineType,
                engine_size: engineSize,
                drive_system: driveSystem
            }

            try {
                const response = await carServices.createCar(payload);

                modalSuccess(this.$bvModal, 'เพิ่มรถสำเร็จ')
                await this.$emit('getCar')
                this.closeModalConfirm();
        
            } catch (err) {
                modalError(this.$bvModal, 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
            }

        },
        closeModalConfirm(){
            this.$refs.observer.reset();
            this.form.show = false
            this.form.isLoad = false
            this.form.car = {
                vehicleType: null,
                vehiclePlate: null,
                province: null,
                brand: null,
                yearCreate: null,
                engineType: null,
                engineSize: null,
                driveSystem: null,
                status: null
            }
        }
    }
}
</script>
